<template>
  <div class="animated">
    <v-client-table
      :columns="columns"
      :data="analytes"
      :options="options"
      :theme="theme"
      id="analyte-table"
      class="w-100"
    >
      <span
        v-if="showColumn('sample_type')"
        slot="sample_type"
        slot-scope="{ row }"
      >
        {{ row.sample_type.name }}
      </span>

      <span v-if="showColumn('name')" slot="name" slot-scope="{ row }">
        <a :href="`#/analytes/${row.id}`" class="btn-link">{{ row.name }}</a>
      </span>

      <span v-if="showColumn('abbrev')" slot="abbrev" slot-scope="{ row }">
        <a :href="`#/analytes/${row.id}`" class="btn-link">{{ row.abbrev }}</a>
      </span>

      <span
        v-if="showColumn('modus_name')"
        slot="modus_name"
        slot-scope="{ row }"
      >
        <a :href="`#/analytes/${row.id}`" class="btn-link">
          {{ row.modus_name }}
        </a>
      </span>

      <span
        v-if="showColumn('description')"
        slot="description"
        slot-scope="{ row }"
      >
        {{ row.description }}
      </span>

      <span v-if="showColumn('actions')" slot="actions" slot-scope="{ row }">
        <a
          class="btn btn-info px-1 py-0 text-white mr-1"
          :href="`#/analytes/${row.id}`"
        >
          <i class="fa fa-eye" />
        </a>
        <a
          class="btn btn-warning px-1 py-0 text-white mr-1"
          :href="`#/analytes/${row.id}/edit`"
        >
          <i class="fa fa-pencil" />
        </a>
        <a
          class="btn btn-danger px-1 py-0 text-white mr-1"
          @click="showDeleteModal(row.id)"
        >
          <i class="fa fa-trash" />
        </a>
      </span>
    </v-client-table>
  </div>
</template>

<script>
import Vue from "vue";
import { ClientTable, Event } from "vue-tables-2";

Vue.use(ClientTable);

export default {
  name: "AnalyteTable",
  components: {
    ClientTable,
    Event
  },
  props: {
    analytes: {
      type: Array
    },
    show_columns: {
      type: Array,
      default: () => [
        "sample_type",
        "name",
        "modus_name",
        "abbrev",
        "description",
        "actions"
      ]
    },
    filterable: {
      type: Array,
      default: () => ["sample_type", "name", "abbrev", "modus_name"]
    },
    sortable: {
      type: Array,
      default: () => ["sample_type", "name", "abbrev", "modus_name"]
    }
  },
  data() {
    return {
      columns: this.show_columns,
      data: this.analytes,
      options: {
        headings: {
          sample_type: "Sample Type",
          name: "Analyte Name",
          abbrev: "Abbrev",
          modus_name: "MODUS"
        },
        sortable: this.sortable,
        filterable: this.filterable,
        sortIcon: {
          base: "fa",
          up: "fa-sort-asc",
          down: "fa-sort-desc",
          is: "fa-sort"
        },
        pagination: {
          chunk: 5,
          edge: false,
          nav: "scroll"
        }
      },
      useVuex: false,
      theme: "bootstrap4",
      template: "default"
    };
  },
  methods: {
    /**
     * Check if the column should be shown
     * @param key
     * @return boolean
     */
    showColumn(key) {
      return this.show_columns.indexOf(key) !== -1;
    },

    /**
     * Handle delete row modal
     * @param id
     */
    showDeleteModal(id) {
      this.$bvModal
        .msgBoxConfirm(
          "You are about to remove this analyte. Do you want to continue?",
          {
            title: "Are you sure?",
            modalClass: ["modal-danger"],
            size: "sm",
            okVariant: "danger",
            okTitle: "YES",
            cancelTitle: "NO",
            footerClass: "p-2",
            centered: true
          }
        )
        .then(() => {
          this.$emit("deleteAnalyte", id);
        });
    }
  }
};
</script>
